import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var KeyboardDoubleArrowUp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
  }));
});
KeyboardDoubleArrowUp.displayName = 'KeyboardDoubleArrowUp';
export var KeyboardDoubleArrowUpDimensions = {
  height: 24,
  width: 24
};